import styled from 'styled-components'
import { theme } from '../../../../styles/theme'

export const PageIntroContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  text-align: center;
  padding: 20px;
  height: 100vh;
`

export const LogoImage = styled.img`
  max-width: 100%;
  height: auto;
`

export const Text = styled.p`
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%;
  letter-spacing: 0.2px;
  color: ${theme.colors.green2};
`

export const ButtonContainer = styled.div`
  margin-top: 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  @media (min-width: 768px) {
    width: 25%;
  }
`

export const ButtonLogin = styled.button`
  background-color: ${theme.colors.green2};
  color: ${theme.colors.white};
  cursor: pointer;
  border-radius: 16px;
  padding: 12px 64px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  width: 100%;
  height: 55px;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
`

export const ButtonSignup = styled.button`
  background-color: ${theme.colors.white};
  border: 1px solid ${theme.colors.green2};
  color: ${theme.colors.green2};
  cursor: pointer;
  border-radius: 16px;
  padding: 12px 64px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  width: 100%;
  height: 55px;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
`

export const ButtonPolicy = styled.a`
  background-color: rgb(255, 255, 255);
  color: rgb(14, 150, 88);
  cursor: pointer;
  border-radius: 16px;
  display: flex;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  width: 100%;
  height: 55px;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
`

export const Header = styled.header`
  button {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    gap: 5px;
    margin: 10px 0 40px 10px;
    color: ${theme.colors.black};
  }
`
